import classes from './InputNumber.module.scss'
import type { ChangeEvent } from 'react'

export interface Props {
  isDisabled?: boolean
  isReadOnly?: boolean
  isRequired?: boolean
  isEmptyValueAllowed?: boolean
  label?: string
  max?: number
  min?: number
  onChange: (value: number) => void
  onClick?: () => void
  value?: number
  id?: string
}

const InputNumber = ({
  isDisabled = false,
  isReadOnly = false, // needed to allow click event instead of disabled prop
  isRequired = true,
  isEmptyValueAllowed = false,
  label,
  max = 999,
  min = 0,
  onChange,
  onClick,
  id,
  value = isEmptyValueAllowed
    ? undefined
    : 1
}: Props) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(parseInt(event.target.value))
  }

  return (
    <input
      aria-label={label}
      className={classes.InputNumber}
      disabled={isDisabled}
      id={id}
      max={max}
      min={min}
      onChange={handleChange}
      onClick={onClick}
      readOnly={isReadOnly}
      required={isRequired}
      type='number'
      value={value}
    />
  )
}

export default InputNumber
